module.exports = __webpack_public_path__ + "img/avin-org-v2.3e19b3a8.jpg";